import { ReactElement, ReactNode, useEffect } from 'react'

import { isAuthorized } from '../../../utils/isAuthorized'

export interface ProtectableProps {
  scopes: Parameters<typeof isAuthorized>[0]
  scopesCheckDisabled?: boolean
}

export interface ProtectableComponentProps extends ProtectableProps {
  unauthorizedNode?: ReactNode
  onUnauthorized?: () => void
}

export interface ProtectedComponentProps extends ProtectableComponentProps {
  children?: ReactNode
}

export const ProtectedComponent = ({
  children,
  onUnauthorized,
  scopes,
  scopesCheckDisabled,
  unauthorizedNode = null,
}: ProtectedComponentProps): ReactElement | null => {
  const isUnauthorized = !isAuthorized(scopes)

  useEffect(() => {
    if (!scopesCheckDisabled && isUnauthorized) {
      onUnauthorized?.()
    }
  }, [isUnauthorized, onUnauthorized, scopesCheckDisabled])

  if (scopesCheckDisabled) {
    return <>{children}</>
  }

  if (isUnauthorized) {
    return <>{unauthorizedNode}</>
  }

  return <>{children}</>
}
